module.exports = __webpack_public_path__ + "media/julia-gruszczynska-cv.66e5d012.mp4";